module.exports = __webpack_public_path__ + "img/icon-wishlist.e37e2189.svg";